import { sql } from "drizzle-orm";

/**
 * Acquires a transaction-scoped advisory lock keyed by `name`.
 * The lock is released automatically when the transaction commits or rolls back.
 */
export async function advisoryLock(
  tx: { execute: (query: ReturnType<typeof sql>) => Promise<unknown> },
  name: string,
  mode: "exclusive" | "shared" = "exclusive"
) {
  await tx.execute(
    mode === "shared"
      ? sql`SELECT pg_advisory_xact_lock_shared(hashtext(${name}))`
      : sql`SELECT pg_advisory_xact_lock(hashtext(${name}))`
  );
}

export async function tryAdvisoryLock(
  tx: { execute: (query: ReturnType<typeof sql>) => Promise<unknown> },
  name: string
): Promise<boolean> {
  const [row] = (await tx.execute(
    sql`SELECT pg_try_advisory_xact_lock(hashtext(${name})) AS locked`
  )) as [{ locked: boolean }];
  return row.locked;
}
